// @ts-nocheck
import { DRAWER_VISIBILITY_CHANGED, SIDER_COLLAPSED, SIDER_EXPANDED } from '../types';

const initialState = {
    isSiderCollapsed: false,
    isDrawerVisible: false,
};

const siderMenu = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SIDER_COLLAPSED: {
            return {
                ...state,
                isSiderCollapsed: true,
            };
        }
        case SIDER_EXPANDED: {
            return {
                ...state,
                isSiderCollapsed: false,
            };
        }
        case DRAWER_VISIBILITY_CHANGED: {
            return {
                ...state,
                isDrawerVisible: payload,
            };
        }
        default:
            return state;
    }
};

export default siderMenu;
